import { createApi } from "redux-future-middleware";
import { requestApi } from "core/api";
import * as types from "./types";

export const getAllInsidersFeedback = createApi({
  name: types.GET_ALL_INSIDERS_FEEDBACK,
  request: () =>
    requestApi({
      path: "/insiders/feedback",
      method: "GET"
    })
});

export const getInsiderFeedback = createApi({
  name: types.GET_INSIDER_FEEDBACK,
  request: ({ targetId, bookingId }) =>
    requestApi({
      path: `/insiders/feedback/get-data/insider/${targetId}/${bookingId}/`,
      method: "GET"
    })
});

export const getCandidateFeedback = createApi({
  name: types.GET_CANDIDATE_FEEDBACK,
  request: ({ targetId, bookingId }) =>
    requestApi({
      path: `/insiders/feedback/get-data/user/${targetId}/${bookingId}/`,
      method: "GET"
    })
});

export const submitInsiderFeedback = createApi({
  name: types.SUBMIT_INSIDER_FEEDBACK,
  request: ({ data, reviewId }) =>
    requestApi({
      path: `/insiders/feedback/update-review/insider/${reviewId}/`,
      method: "PATCH",
      body: data
    })
});

export const submitCandidateFeedback = createApi({
  name: types.SUBMIT_CANDIDATE_FEEDBACK,
  request: ({ data, reviewId }) =>
    requestApi({
      path: `/insiders/feedback/update-review/user/${reviewId}/`,
      method: "PATCH",
      body: data
    })
});

export const addReview = createApi({
  name: types.ADD_REVIEW,
  request: body =>
    requestApi({
      path: "reviews/reviews/",
      method: "POST",
      body
    })
});

export const getCandidateFeedbackResult = createApi({
  name: types.GET_CANDIDATE_FEEDBACK_RESULT,
  request: ({ id }) =>
    requestApi({
      path: `/insiders/feedback/other-part-review/${id}/`,
      method: "GET"
    })
});



// WEBPACK FOOTER //
// ./src/modules/feedback/api.js